import React,{useState} from "react";
import Modal from "react-modal";
import Loading from "./Loading";
//import Inc from "./Include";
import './Hello.scss';

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		zIndex: "100",
		backgroundColor: "rgba(0, 0, 0, 0.5)"
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		padding: "0",
		width:"280px",
		minHeight:"420px",
		transform: "translate(-50%, -50%)"
	}
};

let play;
let event;

function Hello ({ajax,uid,defaultName,close,isOpen}){
    const [name,setName] = useState(defaultName);
    const [error,setError] = useState(null);
	const [isLoading,setIsLoading] = useState(false);
	const [members,setMembers] = useState(null);

    if(!isOpen){
        return (null);
    }

    const afterOpenModal = ()=>{
		
	}
 	const send = ()=>{
        if( !validate() ){
            return false;
        }
        setIsLoading(true);
        ajax("play/new",{uid:uid,name:name},(res)=>{
            console.log(res);
            if( res.ok ){
				play = res.play;
				event = res.event;
				setMembers( res.members );
                //close(res.play,res.event);
            }
            setIsLoading(false);
        });
	}
	const start = ()=>{
		close(play,event,members);
	}
    const auto = ()=>{
        ajax("play/name",{},(res)=>{
            if( res.ok ){
                setName(res.name);
            }
        });
    }
    const validate = ()=>{
		if( name==="" ){
			setError("名前ないはダメです。");
		} else if( name.length>15 ){
            setError("長い名前ダメです。長い言えない。15文字で勘弁するです。");
		} else {
            setError(null);
            return true;
        }
		return false;
	}

    let cl = "";
    if( error ){
        cl = "error";
    }

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={start}
			onAfterOpen={afterOpenModal}
			style={customStyles}
			shouldCloseOnOverlayClick={false}
		>
		<div id="hello">
			{members ? (
			<React.Fragment>
				<div className="face">
					<i className="fas fa-fish"></i> ひとりになると死んじゃう
				</div>
				<div className="text">
					{play.name}のために<span>{members.length}人</span>の仲間が集結した！
				</div>
				<div className="members">
					<ol className="members">
					{members.map((value,index)=>{
						const key="m"+index;
						return (
							<li key={key}>{value}</li>
						)
					})}
					</ol>
				</div>
				<div className="btns">
					<button
						className="ok"
						onClick={start}
					>良い</button>
				</div>
			</React.Fragment>
			):(
			<React.Fragment>
				<div className="face">
					<i className="fas fa-fish"></i> きみは誰？
				</div>
				<div className="text">
					{error ?(
						<div>{error}</div>
					):(
						<div>きみは名前が必要だ。死んだ時、誰だかわからないのは困るから。</div>
					)}
					
				</div>
				<div className="inputs">
					<input type="text"
						value={name}
						onChange={e=>{
							setName(e.target.value);
						}}
						className={cl}
						placeholder="ここに名前書く"
					/>
					<button
						onClick={auto}
					>魚に決めてもらう</button>

				</div>
				<div className="btns">
					<button
						className="ok"
						onClick={send}
					>良い</button>
				</div>
			</React.Fragment>
			)}
            <Loading isLoading={isLoading}/>
		</div>
		</Modal>
	);
}

export default Hello;